import FullScreenLayout from "../../../components/FullScreenLayout";
import { useUserData } from "../../../utils/context/UserDataContext";
import ExpertCard from "../components/ExpertCard";
import { useGetAdmins } from "../hooks/useGetAdmins";
import { useGetNutritionists } from "../hooks/useGetNutritionists";
import { useGetPhysicians } from "../hooks/useGetPhysicians";
import { useGetSpecialists } from "../hooks/useGetSpecialists";

const Experts = () => {
    const { nutritionists, isLoading, error } = useGetNutritionists();
    const { physicians, isLoading: isLoadingPhysicians, error: errorPhysicians } = useGetPhysicians();
    const { specialists, isLoading: isLoadingSpecialists, error: errorSpecialists } = useGetSpecialists();
    const { admins, isLoading: isLoadingAdmins, error: errorAdmins } = useGetAdmins();

    const { userData } = useUserData()
    const email = userData?.email

    const filteredAdmins = admins.filter((admin) => admin.email !== email)

    // Check if any data is still loading
    const isAnyLoading = isLoading || isLoadingPhysicians || isLoadingSpecialists || isLoadingAdmins;

    if (isAnyLoading) {
        return (
            <FullScreenLayout title="Experts">
                <div className="w-full h-full flex flex-col items-center justify-center">
                    <div>
                        Attendi un attimo... <br />
                        Stiamo caricando gli esperti
                    </div>
                </div>
            </FullScreenLayout>
        );
    }

    // Check if there are any errors
    if (error || errorPhysicians || errorSpecialists || errorAdmins) {
        return (
            <FullScreenLayout title="Experts">
                <div className="w-full h-full flex flex-col items-center justify-center">
                    <div>
                        Errore nel caricamento degli esperti. <br />
                        Ti chiediamo di riprovare.
                    </div>
                </div>
            </FullScreenLayout>
        );
    }

    return (
        <FullScreenLayout title="Experts">
            <div className='w-full flex flex-col space-y-8'>
                <div className="flex flex-col space-y-4">
                    <div className="font-bold text-[20px] leading-[33px]">Nutrizionisti</div>
                    <div className="space-y-4">
                        {
                            nutritionists.map((nutritionist) => (
                                <ExpertCard key={nutritionist.id} expert={nutritionist} />
                            ))
                        }
                    </div>
                </div>
                
                <div className="flex flex-col space-y-4">
                    <div className="font-bold text-[20px] leading-[33px]">Endocrinologi</div>
                    <div className="space-y-4">
                        {
                            physicians.map((physician) => (
                                <ExpertCard key={physician.id} expert={physician} />
                            ))
                        }
                    </div>
                </div>
                
                <div className="flex flex-col space-y-4">
                    <div className="font-bold text-[20px] leading-[33px]">Medici refertanti</div>
                    <div className="space-y-4">
                        {
                            specialists.map((specialist) => (
                                <ExpertCard key={specialist.id} expert={specialist} />
                            ))
                        }
                    </div>
                </div>
                
                {
                    filteredAdmins.length > 0 &&
                    <div className="flex flex-col space-y-4">
                        <div className="font-bold text-[20px] leading-[33px]">Admin</div>
                        <div className="space-y-4">
                            {
                                admins.map((admin) => (
                                    <ExpertCard key={admin.id} expert={admin} />
                                ))
                            }
                        </div>
                    </div>
                }
            </div>
        </FullScreenLayout>
    )
}

export default Experts
